import { TooltipProps } from '@mui/material';
import { useMemo } from 'react';

import { InfoCircleIcon } from '@/components/icons/InfoCircleIcon';
import { COLORS } from '@/styles/tokens/colors';

import { Tooltip } from './Tooltip';

interface InfoTooltipProps extends Omit<TooltipProps, 'children'> {
  iconProps?: React.ComponentProps<typeof InfoCircleIcon>;
}

export function InfoTooltip({ iconProps, ...props }: InfoTooltipProps) {
  const iconSx = useMemo(
    () => ({
      color: COLORS.TEXT.SECONDARY,
      display: 'flex',
      cursor: 'pointer',
      ...iconProps?.sx,
    }),
    [iconProps?.sx]
  );

  return (
    <Tooltip {...props}>
      <InfoCircleIcon size={16} {...iconProps} sx={iconSx} />
    </Tooltip>
  );
}
